import React, { useState } from 'react';
import { useCheckRole } from '../auth';
import JoinSimulationDialog from '../JoinSimulationDialog';
import { UserRole } from '../types';
import ActionCard from './ActionCard';
import ContactAvatar from './ContactAvatar';

const JoinSimulationCard = () => {
  useCheckRole([UserRole.Member]);

  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <ActionCard
        actionText="Join by pin"
        avatar={<ContactAvatar />}
        handleClick={show => setShowDialog(show)}
        text="Having a PIN code to join a team session?"
        title="Join a simulation"
        to=""
      />
      <JoinSimulationDialog showDialog={showDialog} reset={() => setShowDialog(false)} />
    </>
  );
};

export default JoinSimulationCard;
